# GraphQL query to get all the emails for a given stage

#import "../fragments/sales-automation-stage-goal.graphql"

query GetGoal($id: ID!) {
    goal(id: $id) {
        ...SalesAutomationStageGoal
    }
}
